import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { of } from 'rxjs';
import { take } from 'rxjs';
import { catchError, map, withLatestFrom } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const ROLES_KEY = 'cognito:groups';

  const ALLOWED_ROLES = ['rep'];

  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    withLatestFrom(oidcSecurityService.getPayloadFromAccessToken()),
    map(([authData, payload]) => {
      if (!authData.isAuthenticated) {
        router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      } else {
        const accessGroups = Array.isArray((payload as any)?.[ROLES_KEY]) ? (payload as any)[ROLES_KEY] : [];
        const userDataGroups = Array.isArray((authData as any)?.userData?.[ROLES_KEY])
          ? (authData as any).userData[ROLES_KEY]
          : [];
        const tokenGroups = accessGroups.length > 0 ? accessGroups : userDataGroups;

        // Check if the user has the correct role
        if (!tokenGroups.some((role: string) => ALLOWED_ROLES.includes(role))) {
          router.navigate(['/login'], { queryParams: { returnUrl: state.url }, state: { forbidden: true } });
          return false;
        } else {
          return true;
        }
      }
    }),
    catchError(() => {
      router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return of(false);
    }),
  );
};
